/**
 * String utility functions
 */

/**
 * Extract a display name from an email address.
 * Formats "john.doe@example.com" -> "John Doe"
 */
export const extractNameFromEmail = (
  email: string | null | undefined,
): string => {
  if (!email) return 'User';
  const atIndex = email.indexOf('@');
  if (atIndex === -1) return email;

  const username = email.substring(0, atIndex);
  // Format: "john.doe" -> "John Doe" or "johndoe" -> "Johndoe"
  return username
    .split('.')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
};

/**
 * Get initials from a name or email.
 * Returns first letter of first and last name, or first letter of email.
 */
export const getInitials = (
  name: string | null | undefined,
  email: string | null | undefined,
): string => {
  if (name) {
    const parts = name.split(' ');
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    }
    return name[0]?.toUpperCase() || '';
  }
  if (email) {
    return email[0]?.toUpperCase() || '';
  }
  return '?';
};
